/**
* $.fn.youtubeplayer
*
* Plugin for Youtube's 3 different players, iframe, chromeless, and flash
*
* @version v1.0.2, 2014-12-03
* @author Fredi Quirino <fred@firefallpro.com>, Scott Park <scott@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2012 Firefall Pro, LLC
*/
/*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, es5:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true */
/*global YT:true, swfobject:true*/
/* Todo:
	- finish skimming documentation to see if there's any changes
	- add comment to methods
	xx- dependency option name should match cross plugin
	xx- remove binding options, they should be available through the proxy events
	xx- log method should be the same across plugins
	xx- dependency method should be the same
	- ability to return jQuery object for volume and seek
*/
(function ($) {
	'use strict';

	// * Means that it is different from what youtube's own documentation says
	var defaultOptions = {
		/** @param {Number} debug controls wether console logs should appear */
		'debug' : 1,
		/** @param {Number} width defines width of video defaulting to 425 */
		'width' : 425,
		/** @param {Number} height defines height of video defaulting to 355 */
		'height' : 355,
		/** @param {String} id for video to use on player in format of : 'vdQj2ohqCBk', required for initializing player except for chromeless */
		'initialVideo' : '',
		/** @param {String} playerType defines type of player (flash, iframe, chromeless) */
		'playerType': 'iframe',
		/** @param {Number} (except as3, chromeless) Forces Iframe to use the html5 player instead of flash by default to null since 0 has no effect and false would be converted to 0 in plugin*/
		'html5' : null,
		/** @param {String} (except iframe) preferredQuality defines type of video quality (video-small, medium, large, hd720, hd1080, highres, default) defaulting to default */
		'preferredQuality' : 'default',
		/** @param {String} (except iframe) setting is used to create swf object with transparent background*/
		'wmode' : 'transparent',
		/** @param {String} (except iframe) url to be used to load flash dependencies*/
		'url_swfobject' : '//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js',
		/** @param {String} (except as3, chromeless) url to be used to load iframe dependencies*/
		'url_iframe' : 'https://www.youtube.com/iframe_api',
		/** @param {String} Absolute path of current script*/
		'script_path' : null,
		/** @param {String} Partial Filename of plugin (should never be the exact name) used to find script tag and get script_path*/
		'plugin_name' : 'player.youtube',
		/** @param {Number} autohide fades control bar out (2) slides in if user mouses over (1), visible throughout in fs (0)*/
		'autohide' : 2,
		/** @param {Number} autoplay plays the video automatically (0) or does not play the video automatically (1) */
		'autoplay' : 0,
		/** @param {Number} (except iframe/html5) cc_load_policy displays closed captions by default (1) or does not display closed captions (0) (flash)*/
		'cc_load_policy' : 0,
		/** @param {String} (except chromeless) color highlights the amount of video seen in (red) or (white)*/
		'color' : 'red',
		/** @param {Number} (except chromeless) controls displays related videos (1), or doesn't display related videos (0)*/
		'controls' : 1,
		/** @param {Number} (except iframe/html5*) disablekb defines keyboard controls as enabled (0), or keyboard controls as disabled (1) */
		'disablekb' : 0,
		/** @param {Number} (*) specifies the time when the player should stop playing the video */
		'end' : 0,
		/** @param {Number} (except chromeless*) fs displays full screen button(1) or doesn't display fullscreen button(0) AS3: defaults to 1,
		AS2: defaults to 0, and requires "<param name="allowFullScreen" value="true"></param>" for as2*/
		'fs' : 1,
		/** @param {Number} iv_load_policy displays video annotations (1) , or video annotations not shown (0) */
		'iv_load_policy' : 1,
		/** @param {String} (except iframe/html5) list identifies content that will load in player (0) */
		'list' : '',
		/** @param {String} (except iframe/html5) The listType parameter, in conjunction with the list parameter, identifies the content that will load in the player. Valid parameter values are playlist, search, and user_uploads. */
		'listType' : '',
		/** @param {Number} (workaround for AS3 and chromeless) loops identifies when a video will loop (1) or doesn't loop (0), AS3 works only when playlist is used */
		'loop' : 0,
		/** @param {Number} (except chromeless) modestbranding prevents youtube logo from displaying (1) */
		'modestbranding' : 1,
		/** @param {String} (except as3, chromeless) This parameter provides an extra security measure for the IFrame API and is only supported for IFrame embeds. If you are using the IFrame API, which means you are setting the enablejsapi parameter value to 1, you should always specify your domain as the origin parameter value. */
		'origin' : '',
		/** @param {String} (except iframe/html5*) playlist displays a list with NO SPACES of video ids to play *kicks player into flash iframe*/
		'playlist' : '',
		/** @param {Number} (except chromeless) rel displays related videos (1) or does not display related videos (0) */
		'rel' : 1,
		/** @param {Number} (except chromeless) showinfo displays video title and uploader (1), or doesn't display video title and uploader (0) */
		'showinfo' : 1,
		/** @param {Number} start begins playing video at given number of seconds, any positive integer */
		'start' : 0,
		/** @param {String} (except chromeless) theme displays a (dark) or (light) control bar */
		'theme' : 'dark'
	};
	
	var methods = {
		/**
		* _log
		*
		* Prefixes all debugging logs with plugin name, If IE is present then it opts for using strings when available rather
		* than an object, IE7 and 8 do not show contents of consoled objects. Method concatenates first and second arguments
		* if they're string literals before passing them to console log, otherwise it passes the whole arguments array
		*/
		'_log' : function () {
			if (!$.fn.youtubeplayer.debug) return;
			
			var ie = !$.support.opacity, args = arguments, str = '';
			
			if (ie && typeof arguments[0] === 'string' && typeof arguments[1] === 'string') str = arguments[0] + ' ' + arguments[1];
			else if (ie && typeof arguments[0] === 'string') str = arguments[0];
			
			console.log(defaultOptions['plugin_name'], (ie) ? str : args);
		},
		/**
		* _script_path - Sets the absolute path to the current loaded script or parent script if it was loaded by another plugin
		*
		* @param {object} options Holds the options for player to be created or to be interacted with
		* @returns {string} returns the new absolute path
		*/
		'_script_path' : function (o) {
			// Determine path of current script
			if (o.script_path === null) {
				var $script = $('script[src*="' + o.plugin_name + '"]');
				if ($script.length === 0) return '/';
				return $script[0].src;
			} else {
				var a = document.createElement('a');
				a.href = o.script_path;
				return a.href;
			}
		},
		/**
		* _base_path - Accepts a path and trims the ending, returns the new path.
		*
		* @param {string} path Pathname that will be trimmed
		* @returns {string} returns the new pathname
		*/
		'_base_path' : function (path) {
			return path.substr(0, path.lastIndexOf('/'));
		},
		/**
		* _dependency
		*
		* Helps to load dependencies sequentially, but can also load asynchronous. Key of mapped objects must
		* be the name of the file e.g 'swfobject.js' : {}. Queues dependencies on 'body' and adds the callback
		* if any as the last queued function.
		*
		* @param {object} dependencies An object that holds a map of dependencies that need to be loaded and their settings
		*	@param {boolean} dependencies.async
		*	If 'false' it will load dependencies sequentially and wait until it gets a result before
		*	going on to the next dependency, otherwise if 'true' it will not wait for the results and trigger the next dependency
		*
		*	@param {string} dependencies.url
		*	This is the location to the dependency,  if omitted the url will be constructed using
		*	the path in 'options.script_path' along with the filename/key
		*
		*	@param {function} dependencies.test A function that returns either true or false, used to test if dependency has already been loaded
		*	@param {function} dependencies.callback A function to be called after dependency is loaded successfully
		* @param {object} options Holds the options for player to be created
		* @param {function} callback Supplies a function to be called at completion, optionally
		*/
		'_dependency' : function (dependencies, options, callback) {
			
			var $body = $('body');
			
			$.each(dependencies, function (filename, file) {
				
				// Dependency state
				if (typeof dependency[filename] === 'undefined') dependency[filename] = 0;
				
				// Check if already loaded
				if (dependency[filename] === 2 || file.test()) {
					methods._log(filename + ' is already loaded');
					dependency[filename] = 2;
					if (typeof file.callback !== 'undefined') file.callback();
					return;
				}
				
				// URL
				if (file.url === null) file.url = methods._base_path(options.script_path) + '/' + filename;
				
				methods['_log']('load script at ' + file.url);
				
				// Queue
				$body.queue('player', function (next) {
					
					if (dependency[filename] === 0) {
						// Signal loading
						methods._log('Loading ' + filename);
						
						dependency[filename] = 1;
						
						// Load Script
						dependency[filename + '_promise'] = $.ajax({
							'cached' : true,
							'dataType' : 'script',
							'error' : function () {
								$.error('Failed to load dependency: ' + file.url);
							},
							'success' : function () {
								methods._log(filename + ' loaded');
								
								dependency[filename] = 2;
								if (typeof file.callback !== 'undefined') file.callback();
								if (!file.async) next();
							},
							'url' : file.url
						});
						if (file.async) next();
						return;
					}
					
					methods._log(filename + 'has already been started');
					
					dependency[filename + '_promise'].done(function () {
						methods._log(filename + ' loaded');
						if (typeof file.callback !== 'undefined') file.callback();
					});
					
					if (file.async) next();
					
				});
			});
			
			// Queue callback if set
			if (typeof callback !== 'undefined') {
				$body.queue('player', function (next) {
					methods['_log']('Queue is complete');
					
					callback();
					next();
				});
			}
			
			// Start queue
			$body.dequeue('player');
		},
		/**
		* init
		*
		* initiates dependencies, loads the needed dependency depending on which player the target
		* needs or skips the process if target has been initiated
		*
		* @param {object} options Holds the options for player to be created or to be interacted with
		* @param {function} callback Supplies a function to be called at completion, optionally
		* @returns {obect} returns jQuery object
		*/
		'init' : function (options, callback) {
			
			// Toggle debug
			if (options['debug']) $.fn.youtubeplayer.debug = true;
			
			// Merge specified options with defaults
			var o = $.extend({}, defaultOptions, options);
			
			var result = this;
			
			this.each(function () {
				var $this = $(this);
				
				// assume that existing players can't change there playerType unless destroying first
				if (typeof $this.data('player') !== 'undefined') {
					methods._log('skipping init');
					
					if (typeof callback !== 'undefined') {
						result = callback.call($this);
					}
					
					return;
				}
				
				var dependencies = {
					'swfobject.js' : {
						'url' : o['url_swfobject'],
						'async' : true,
						'test' : function () { return (typeof swfobject !== 'undefined'); }

					},
					'iframe_api' : {
						'url' : o['url_iframe'],
						'async' : true,
						'test' : function () { return (typeof YT !== 'undefined'); }
					}
				};
		
				// Player type is flash player or chromeless player
				if (o.playerType !== 'iframe') {
					delete dependencies['iframe_api'];
						
					dependencies['swfobject.js'].callback = function () {
						if (typeof callback !== 'undefined') callback.call($this);
					};
		
				// Player type is iFrame
				} else {
					delete dependencies['swfobject.js'];
					
					dependencies['iframe_api'].callback = function () {
						if (!dependency.iframeInited && typeof YT.Player !== 'undefined') dependency.iframeInited = true;
						if (typeof callback !== 'undefined') callback.call($this);
					};
				}
				
				// Validate script path is not null
				o['script_path'] = methods['_script_path'](o);
				
				methods['_log']('script_path is', o['script_path']);
				
				methods['_dependency'](dependencies, o);
				
				result = $this;
			});
			
			return result;
		},
		/**
		* initPlayer
		*
		* initiates target before adding actual player or passing along arguments to specified method if player exists, Exits out
		* early if it does not have sufficient info for creating the player and only loading dependencies.
		*
		* @param {string} fn The name of the method that should be triggered once player is loaded, ignored if its 'init' or 'initPlayer'
		* @param {object} player An object that holds properties for this element
		* @param {string} args If player doesn't exist, args can be a URL for video, if it does exist then pass along args to method
		* @param {object} options Holds the options for player to be created or to be interacted with
		* @param {function} callback Supplies a function to be called at completion, optionally
		*/
		'initPlayer' : function (fn, args, options, callback) {
			var $this = $(this);
			
			// for some reason options start becoming pointers if only left inside init
			var o = $.extend({}, defaultOptions, options);
			
			// Initialized player
			if (typeof $this.data('player') !== 'undefined') {
				methods['_log']('Element has initialized player');
				
				// Re-merge old options on element with any new ones
				o = $.extend({}, $.fn.youtubeplayer.player[$this.data('player')['id']].options, options);
				$.fn.youtubeplayer.player[$this.data('player')['id']].options = o;
				
				if (fn !== 'init' && fn !== 'initPlayer') return methods[fn].call($this, $.fn.youtubeplayer.player[o.player_ID], args, callback);
				
				return $this;
			
			}
			
			// Uninitialized player
			methods['_log']('Element has uninitialized player');
			
			// If true, dependency load and nothing more
			var dependency_only = false;
			
			// Validation : check wether youtube url is in ARGUMENTS or in OPTIONS, API needs valid Video ID except for chromeless
			if (!$.fn.youtubeplayer.parse_youtube_id(o.initialVideo) && typeof args === 'string' && $.fn.youtubeplayer.parse_youtube_id(args)) {
				o.initialVideo = $.fn.youtubeplayer.parse_youtube_id(args);
				args = '';
				
			} else if (!$.fn.youtubeplayer.parse_youtube_id(o.initialVideo) && o.playerType !== 'chromeless') {
				dependency_only = true;
			
			// Url was given in options
			} else {
				o.initialVideo = $.fn.youtubeplayer.parse_youtube_id(o.initialVideo);
			}
			
			// Validation : check for methods that should do nothing
			if (typeof fn === 'destroy') dependency_only = true;
			
			if (dependency_only) {
				methods['_log']('Element has no valid video ID or invalid method, will load dependencies', o);
				return;
			}
			
			o.player_ID = 'youtubeplayer_' + $.fn.youtubeplayer.current_ID++;
			var container = document.createElement('div');
			container.id = o.player_ID;
			$this.append(container).data('player', {
				'type' : 'youtube',
				'id' : o.player_ID
			});
			
			// Store player's options in Player Array
			$.fn.youtubeplayer.player[o.player_ID] = {
				'options' : o
			};
			
			// Player type is flash player or chromeless player
			if (o.playerType !== 'iframe') {
				methods['_log']('Element has Flash Player');
				
				methods['createFlashPlayer'].call($(this), o);
				
			// Player type is iFrame
			} else {
				methods['_log']('Element has Iframe Player');
				
				// Must be queued, dependency must call globally defined function
				$this.queue('player', function (next) {
					methods['createIframePlayer'].call($this, o, next);
					//next();
				});
				
				// IE calls globally defined function before initPlayer
				if (dependency.iframeInited) {
					$this.dequeue('player');
				}
			}
			
			// Callback for init, e.g 'play' initializes player
			if (fn !== 'init' && fn !== 'initPlayer') {
				methods._log(fn + ' is being queued');
				
				$this.queue('player', function (next) {
					methods._log(fn + ' queued method is being triggered');
					methods[fn].call($this, $.fn.youtubeplayer.player[o.player_ID], args, callback);
					next();
				});
				
				/*if (dependency.iframeInited && o.playerType === 'iframe') {
					$this.dequeue('player');
				}*/
			}
			
			
		},
		/**
		* load - loads the specified video and plays the video.
		*
		* @param {object} player An object that holds properties for this element
		* @param {string} setting A url to youtube video
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'load' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// Get Player
			var youtubeplayer = player.youtubeplayer;
			
			var url = $.fn.youtubeplayer.parse_youtube_id(setting);
			if (!url) return this;
			
			youtubeplayer.loadVideoById(url, player.options.start, player.options.preferredQuality);
			player.options.initialVideo = url;
			
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		},
		/**
		* cue - loads the specified video and prepares the player to play the video.
		*
		* @param {object} player An object that holds properties for this element
		* @param {string} setting A url to youtube video
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'cue' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// Get Player
			var youtubeplayer = player.youtubeplayer;
			
			var url = $.fn.youtubeplayer.parse_youtube_id(setting);
			if (!url) return this;
			
			youtubeplayer.cueVideoById(url, player.options.start, player.options.preferredQuality);
			player.options.initialVideo = url;
			
			if (typeof callback !== 'undefined') callback.call(this);
			return this;
		},
		/**
		* play - plays the video
		*
		* @param {object} player An object that holds properties for this element
		* @param {object} setting A plugin options object, optionally
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'play' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// Get Player
			var youtubeplayer = player.youtubeplayer;
			
			var state = youtubeplayer.getPlayerState();
			
			// If setting is url assume its a new video, load video and then play
			if (typeof setting === 'string' && setting.length) methods['load'](player, setting, callback);
			
			// Return if Buffering or is Playing
			if (state === 3 || state === 1) return this;
			
			youtubeplayer.playVideo();
			if (typeof callback !== 'undefined') callback.call(this);
			
			return this;
		},
		
		/**
		* pause - pauses the video
		*
		* @param {object} player An object that holds properties for this element
		* @param {boolean} setting Two optional values: true (forces pause), false (doesn't force pause), no value (toggle)
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'pause' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// Check state of player
			var youtubeplayer = player.youtubeplayer;
			var state = youtubeplayer.getPlayerState();
			
			// Return if not Playing or Paused
			if (state !== 1 && state !== 2) return this;
			
			// Normalize Input
			if (typeof setting !== 'undefined' && setting !== null) setting = (setting) ? true : false;
			
			methods['_log']('Pause Value Before Change', setting, state);
			
			// Pause
			if (setting || (state === 1 && setting !== false)) {
				youtubeplayer.pauseVideo();
				
			// Un-Pause
			} else if (!setting || (state === 2 && setting !== true)) {
				youtubeplayer.playVideo();
			}
			
			methods['_log']('Pause Value After Change', setting, youtubeplayer.getPlayerState());
			
			if (typeof callback !== 'undefined') callback.call(this);
			
			return this;
		},
		
		/**
		* stop - stops the video
		*
		* @param {object} player An object that holds properties for this element
		* @param {undefined} setting Ignored
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		'stop' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// stop the video
			player.youtubeplayer.stopVideo();
			
			if (typeof callback !== 'undefined') callback.call(this);
			
			return this;
		},
		
		/**
		* volume - sets and returns volume of player
		*
		* @param {object} player An object that holds properties for this element
		* @param {Number} setting Defines the settings for volume, integer 0-100
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {Number} returns to previous volume, integer 0-100
		*/
		'volume' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// Get Player
			var youtubeplayer = player.youtubeplayer;
			
			var volume = youtubeplayer.getVolume();
			
			methods['_log']('Volume Value Before Change', setting, volume);
			
			// Normalize Input
			if (typeof setting !== 'undefined' && setting !== null) {
				
				setting = parseInt(setting, 10);
				// Check for valid volume
				if (setting < 0) setting = 0;
				if (setting > 100) setting = 100;
				
				// Set volume of player
				youtubeplayer.setVolume(setting);
			}
			
			methods['_log']('Volume Value After Change', setting, youtubeplayer.getVolume());
			
			if (typeof callback !== 'undefined') callback.call(this);
			
			return volume;
		},
		
		/**
		* mute - mutes and unmutes volume of player
		*
		* @param {object} player An object that holds properties for this element
		* @param {boolean} setting Two optional values: true (mute) and false (unmute)
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		
		'mute' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			// Check state of player
			var youtubeplayer = player.youtubeplayer;
			var state = youtubeplayer.getPlayerState();
			
			// Return if not Playing or Paused
			if (state !== 1 && state !== 2) return this;
			
			var mute = youtubeplayer.isMuted();
			
			// Normalize Input
			if (typeof setting !== 'undefined' && setting !== null) setting = (setting) ? true : false;
			
			methods['_log']('Mute Value Before Change', setting, mute);
			
			// Mute
			if (setting || (!mute && setting !== false)) {
				youtubeplayer.mute();
				
			// Un-mute
			} else if (setting === false || mute) {
				youtubeplayer.unMute();
			}
			
			methods['_log']('Mute Value After Change', setting, youtubeplayer.isMuted());
			
			if (typeof callback !== 'undefined') callback.call(this);
			
			return this;
		},
		
		/**
		* seek - seeks to a specified time in the video
		*
		* @param {object} player An object that holds properties for this element
		* @param {Number} setting Maintains the same playing/paused state while seeking to a specified time, in seconds
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {Number} returns the previous seek time in seconds
		*/
		'seek' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			var seek = player.youtubeplayer.getCurrentTime();
			var state = player.youtubeplayer.getPlayerState();
			
			// Return if not Playing or Paused
			if (state !== 1 && state !== 2) return this;
			
			methods['_log']('Seek Value Before Change', setting, seek);
			
			// Normalize Input
			if (typeof setting !== 'undefined' && setting !== null) {
				setting = parseInt(setting, 10);
				player.youtubeplayer.seekTo(setting);
			}
			
			methods['_log']('Seek Value Before Change', setting, player.youtubeplayer.getCurrentTime());
			
			methods['_log']('callback', typeof callback);
			
			if (typeof callback !== 'undefined') callback.call(this);
			
			return seek;
		},
		
		/**
		* destroy - destroys player
		*
		* @param {object} player An object that holds properties for this element
		* @param {undefined} setting Ignored
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns a jQuery object
		*/
		
		'destroy' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			player.youtubeplayer.stopVideo();
			
			// Flash
			if (player.options.playerType !== 'iframe') {
				swfobject.removeSWF(player.options.player_ID);
			}
			
			// Reset
			// removes data, binds and children
			this.removeClass('video').removeData('player').children('#' + player.options.player_ID).attr('src', '#');
			this.empty();
			
			$.fn.youtubeplayer.player[player.options.player_ID] = null;
			
			if (typeof callback !== 'undefined') callback.call(this);
			
			return this;
		},
		/**
		* info - Returns information on player
		* @param {object} player An object that holds properties for this element
		* @param {string} setting A string specifying what information should be returned, if undefined an object with all information is returned
		* @param {function} callback Supplies a function to be called at completion, optionally
		*
		* @returns {object} returns an object or a float or an int or a boolean
		*/
		'info' : function (player, setting, callback) {
			if (typeof player.youtubeplayer === 'undefined') return this;
			
			var result;
			
			switch (setting) {
			case 'currentTime':
				result = player.youtubeplayer.getCurrentTime();
				break;
				
			case 'duration':
				result = player.youtubeplayer.getDuration();
				break;
				
			case 'loaded':
				result = player.youtubeplayer.getVideoLoadedFraction();
				break;
				
			case 'state':
				result = player.youtubeplayer.getPlayerState();
				break;
			case 'muted':
				result = player.youtubeplayer.isMuted();
				break;
				
			default:
				result = {
					'currentTime' : player.youtubeplayer.getCurrentTime(),
					'duration' : player.youtubeplayer.getDuration(),
					'loaded' : player.youtubeplayer.getVideoLoadedFraction(),
					'state' : player.youtubeplayer.getPlayerState(),
					'muted' : player.youtubeplayer.isMuted()
				};
			}
			
			methods['_log']('Info requested', setting, result);
			if (typeof callback !== 'undefined') callback.call(this);
			
			return result;
		},
		/**
		* supportsHTML5 - check if video for HTML5 is supported
		* http://diveintohtml5.info/detect.html#video-formats
		*/
		// http://diveintohtml5.info/detect.html#video-formats
		'supportsHTML5' : function () {
			methods['_log']('Support function triggered');
			return !!document.createElement('video').canPlayType;
		},
		/**
		* createIframePlayer - Creates the Iframe Player on target element using the passed options and triggers 'init.player' event on target
		*
		* @param {object} o An object of properties for the player that will be created
		* @param {function} next Optional, used to advance jquery's queue when createIframePlayer is called before API is ready, this is different on IE/Current browsers
		*/
		'createIframePlayer' : function (o, next) {
			methods['_log']('Creating IFRAME player', o);
			
			var $parent = this;
			var playerVars = {
				//https://developers.google.com/youtube/player_parameters?playerVersion=HTML5
				'autohide' : o.autohide,
				'autoplay' : o.autoplay,
				'color' : o.color,
				'cc_load_policy' : o.cc_load_policy,
				'controls' : o.controls,
				'disablekb' : o.disablekb,
				'end' : o.end,
				'wmode' : o.wmode,
				'fs' : o.fs,
				'list' : o.list,
				'listType' : o.listType,
				'html5' : o.html5,
				'iv_load_policy' : o.iv_load_policy,
				'loop' : o.loop,
				'modestbranding' : o.modestbranding,
				'origin' : o.origin,
				'playlist' : o.playlist,
				'rel' : o.rel,
				'showinfo' : o.showinfo,
				'start' : o.start,
				'theme' : o.theme
			};
			
			// Iframe Workarounds Applied
				
			if (o.preferredQuality !== 'default') playerVars.vq = o.preferredQuality;
			
			var Yt = new YT.Player(o.player_ID, {
				'height' : o.height,
				'width' : o.width,
				'videoId' : o.initialVideo,
				'playerVars' : playerVars,
				'events' : {
					'onReady' : function (evt) {
							methods['_log']('onReady : Iframe');
							var youtubeplayer = evt.target;
							var id = o.player_ID;
							
							$.fn.youtubeplayer.player[id].youtubeplayer = youtubeplayer;
							
							// Proxy known events
							$('#' + id).on('playing, unstarted, ended, pause, buffering, cued, ready, qualitychange', function (e, arg) {
								// Debug
								methods._log('event', e.type, arg);
								
								// Namespace events to the container
								$(this).parent().trigger(e.type + '.player', arg);
							});
							
							$parent.queue('player', function (this_next) {
								// Trigger local event
								$(this).trigger('ready.player');
								this_next();
							});
							
							if (typeof next !== 'undefined') next();
						},
					'onStateChange' : function (state) {
							methods['onStateChange'].call($parent, o.player_ID, state);
						},
					'onPlaybackQualityChange' : function (quality) {
							methods['onPlaybackQualityChange'].call($parent, o.player_ID, quality);
						},
					'onError' : function (error) {
							methods['onError'].call($parent, o.player_ID, error);
						}
				}
			});
			
			// Trigger Element init.player
			this.trigger('init.player');
		},
		/**
		* onStateChange - Normalizes states for flash and iframe and triggers local events on target element
		*
		* @param {string} id The ID for the youtube player
		* @param {*} state Is an object if player has iframe, otherwise its an integer
		*/
		'onStateChange' : function (id, state) {
			methods['_log']('onStateChange : Iframe and Flash');
			
			// Normalize State from both Iframe and Flash
			var value = (typeof state === 'object') ? state.data : state;
			
			// Trigger local binds on elements
			switch (value) {
			case -1:// unstarted
				//methods['_log']('unstarted', id, value);
				$('#' + id).trigger('unstarted');
				break;
				
			case 0:// ended
				//methods['_log']('ended', id, value);
				$('#' + id).trigger('ended');
				break;
				
			case 1:// playing
				//methods['_log']('playing', id, value, $('#' + id));
				$('#' + id).trigger('playing');
				break;
				
			case 2:// pause
				//methods['_log']('pause', id, value);
				$('#' + id).trigger('pause');
				break;
				
			case 3:// buffering
				//methods['_log']('buffering', id, value);
				$('#' + id).trigger('buffering');
				break;
				
			case 5:// video cued
				//methods['_log']('video cued', id, value);
				$('#' + id).trigger('cued');
				break;
				
			default:
				//methods['_log']('default', arguments);
			}
		},
		/**
		* onPlaybackQualityChange - Normalizes quality for flash and iframe and triggers local events on target element
		*
		* @param {string} id The ID for the youtube player
		* @param {*} quality Is an object if player has iframe, otherwise its a string
		*/
		'onPlaybackQualityChange' : function (id, quality) {
			methods['_log']('onPlaybackQualityChange: Iframe and Flash', quality);
			
			// Normalize quality
			var value = (typeof quality === 'object') ? quality.data : quality;
			
			// Trigger individual element's bind
			$('#' + id).trigger('qualitychanged', [value]);// As of jQuery 1.6.2, a single parameter can be passed without using an array.
		},
		/**
		* onError - Triggers local events on target element
		*
		* @param {string} id The ID for the youtube player
		* @param {*} error Error on youtube player
		*/
		'onError' : function (id, error) {
			methods['_log']('onError: Iframe and Flash', arguments);
			
			// Trigger individual element's bind
			$('#' + id).trigger('error', [error]);// As of jQuery 1.6.2, a single parameter can be passed without using an array.
		},
		/**
		* createFlashPlayer
		*
		* Creates the flash Player on target element using the passed options and triggers 'init.player' event on target,
		* options applied depend on wether 'chromeless' player is needed. Flash API requires global functions to be available.
		*
		* @param {object} o An object of properties for the player that will be created
		*/
		'createFlashPlayer' : function (o) {
			methods['_log']('Creating Flash player', o);
			
			// General options
			var params = {
				'allowScriptAccess' : 'always',
				'allowFullScreen' : o.fs,
				'wmode' : o.wmode
			};
			var atts = {
				'id' : o.player_ID
			};
			var url = 'https://www.youtube.com';
			var option = {
				'enablejsapi' : '1',
				'version' : '3'
			};
			
			// AS3 Parameter Workaround Applied
			if (o.loop && o.playlist === '') o.playlist = o.initialVideo;
			
			// Chromeless Player URL
			if (o.playerType === 'chromeless') {
				url += '/apiplayer?';
				option.video_id = o.initialVideo;
				option.autoplay = o.autoplay;
				option.cc_load_policy = o.cc_load_policy;
				option.end = o.end;
				option.iv_load_policy = o.iv_load_policy;
				option.disablekb = o.disablekb;
				option.loop = o.loop;
				option.list = o.list;
				option.listType = o.listType;
				option.playlist = o.playlist;
				option.start = o.start;
				option.playerapiid = o.player_ID;
			
			// Flash Player URL
			} else {
				url += '/v/' + o.initialVideo;
				option.autohide = o.autohide;
				option.autoplay = o.autoplay;
				option.cc_load_policy = o.cc_load_policy;
				option.color = o.color;
				option.controls = o.controls;
				option.disablekb = o.disablekb;
				option.end = o.end;
				option.fs = o.fs;
				option.iv_load_policy = o.iv_load_policy;
				option.loop = o.loop;
				option.list = o.list;
				option.listType = o.listType;
				option.modestbranding = o.modestbranding;
				option.playerapiid = o.player_ID;
				option.playlist = o.playlist;
				option.rel = o.rel;
				option.showinfo = o.showinfo;
				option.start = o.start;
				option.theme = o.theme;
			}
			
			// Assemble URL
			url += '?' + $.param(option);
			
			methods['_log']('URL', url);
			
			// Trigger Element init.player
			this.trigger('init.player');
			
			// Embed
			swfobject.embedSWF(url, o.player_ID, o.width, o.height, '8', null, null, params, atts);
			
			// API Triggers methods.onYouTubePlayerReady
		},
		/**
		* onYouTubePlayerReady
		*
		* This method is triggered by a globally defined function 'onYouTubePlayerReady' which
		* the API calls every single time a player is created. This method links the other functions
		* that the API needs to methods within the scope of this plugin. Binds events to the youtube player
		* so they can bubble up to the parent. Makes sure the ready event is triggered after all queued callbacks
		* have already been triggered.
		*
		* @param {string} player_ID The ID of the youtube player that triggered the event
		*/
		'onYouTubePlayerReady' : function (player_ID) {
			
			// Find Unique Player
			var youtubeplayer = $('#' + player_ID)[0];
			var $target = $(youtubeplayer).parent();
			
			// Proxy known events
			$(youtubeplayer).on('playing, unstarted, ended, pause, buffering, cued, ready, qualitychange', function (e, arg) {
				// Debug
				methods._log('event', e.type, arg);
			
				// Namespace events to the container
				$(this).parent().trigger(e.type + '.player', arg);
			});
			
			// Store player object
			$.fn.youtubeplayer.player[player_ID]['youtubeplayer'] = youtubeplayer;
			
			// EXPOSING FUNCTIONS TO API
			$.fn.youtubeplayer.callbacks['onStateChange']['player_' + player_ID] = function (state) {
				methods['onStateChange'].call($target, player_ID, state);
			};
			
			$.fn.youtubeplayer.callbacks['onPlaybackQualityChange']['player_' + player_ID] = function (quality) {
				methods['onPlaybackQualityChange'].call($target, player_ID, quality);
			};
			
			$.fn.youtubeplayer.callbacks['onError']['player_' + player_ID] = function (error) {
				methods['onError'].call($target, player_ID, error);
			};
			
			// Add API EventListeners // Youtube customized there methods // works only with 'addEventListener' // only takes in a STRING
				// onState
			var callback = '$.fn.youtubeplayer.callbacks.onStateChange.player_' + player_ID;
			youtubeplayer.addEventListener('onStateChange', callback);
			
				// onPlaybackQualityChange
			callback = '$.fn.youtubeplayer.callbacks.onPlaybackQualityChange.player_' + player_ID;
			youtubeplayer.addEventListener('onPlaybackQualityChange', callback);
			
				// onError
			callback = '$.fn.youtubeplayer.callbacks.onError.player_' + player_ID;
			youtubeplayer.addEventListener('onError', callback);
			
			
			$target.queue('player', function (next) {
				// Trigger local event
				$(this).trigger('ready.player');
				next();
			});
			
			// Dequeue element stack
			$target.dequeue('player');
		}
	};
	
	$.fn.youtubeplayer = function () {
		var fn = 'init', args, settings = {}, callback;
		
		// Assign arguments
		for (var i = 0; i < arguments.length; i++) {
			switch (typeof arguments[i]) {
			
			// Callback
			case 'function':
				callback = arguments[i];
				break;
			
			// Settings
			case 'object':
				settings = arguments[i];
				break;
			
			// Ignore undefined
			case 'undefined':
				break;
			
			// Function or Argument
			case 'string':
			default:
				if (methods[arguments[i]]) fn = arguments[i];
				else args = arguments[i];
			}
		}
		
		methods._log(fn);
		
		// type checking options that will be merged with default options
		for (var op in settings) {
			if (settings.hasOwnProperty(op)) {
				// Convert boolean to int
				if (typeof settings[op] === 'boolean') settings[op] = Number(settings[op]);
		
				// Default option for invalid type
				if (typeof settings[op] !== typeof defaultOptions[op] && defaultOptions[op] !== null) settings[op] = defaultOptions[op];
			}
		}
		
		// Everyone Must go through init
		return methods['init'].call(this, settings, function () {
			return methods['initPlayer'].call(this, fn, args, settings, callback);
		});
	};
	
	// Increment to be used to assign ID's to players
	$.fn.youtubeplayer.current_ID = 0;
	
	// Global variable to store Players data
	$.fn.youtubeplayer.player = {};
	
	// Flags for dependencies // 0 unloaded, 1 loading, 2 loaded
	var dependency = $.fn.youtubeplayer.dependency = {
		'iframeInited' : false
	};
	
	// Global debug
	$.fn.youtubeplayer.debug = false;
	
	// Global for FLASH API // links to plugin scope
	$.fn.youtubeplayer.callbacks = {
		'onYouTubePlayerReady' : methods['onYouTubePlayerReady'],
		'onStateChange' : {},
		'onPlaybackQualityChange' : {},
		'onError' : {}
	};
	
	// One time check for Support
	$.fn.youtubeplayer.supportsHTML5 = methods['supportsHTML5']();
	
	/**
	* parse_youtube_id - Extracts the YouTube ID from a string
	*/
	$.fn.youtubeplayer.parse_youtube_id = function (url) {
		var start,
			end;
		
		// Validate Input
		if (typeof url !== 'string') { return false; }
		
		if ((start = url.indexOf('youtu.be/')) !== -1) { // Short URL
			start += 'youtu.be/'.length;
		} else if ((start = url.indexOf('v=')) !== -1) { // Traditional URL
			start += 'v='.length;
		} else if (url.length === 11) {
			return url;// ID only
		} else {
			return false;
		}
		
		// Extract ID
		if ((end = url.indexOf('&', start)) !== -1) {
			return url.substring(start, end);
		} else {
			return url.substring(start);
		}
	};
})(jQuery);

function onYouTubeIframeAPIReady() {
	if (jQuery.fn.youtubeplayer.debug) console.log('Iframe API Ready');
	
	// Flag Iframe is loaded
	if (!jQuery.fn.youtubeplayer.dependency.iframeInited) jQuery.fn.youtubeplayer.dependency.iframeInited = true;
	
	// Start any queued methods on Iframe elements
	jQuery.each(jQuery.fn.youtubeplayer.player, function () {
		if (this.options.playerType !== 'iframe') return;
		jQuery('#' + this.options.player_ID).parent().dequeue('player');
	});
}

function onYouTubePlayerReady(player_ID) {
	if (jQuery.fn.youtubeplayer.debug) console.log('Flash API Ready ', player_ID);
	
	jQuery.fn.youtubeplayer.callbacks['onYouTubePlayerReady'](player_ID);
}

